import React, { useEffect, useState } from 'react';
import { requester } from 'App';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import Container from 'layouts/container/Container';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileCateList from 'routes/adminMobile/components/AdminMobileCateList';
import AdminMobileRegisterBtn from '../components/common/AdminMobileRegisterBtn';

const AdminMobileCategory = () => {
    const [isMounted, setMounted] = useState(false);

    // 카테고리 리스트와 필터링된 카테고리 리스트를 상태로 관리
    const [categories, setCategories] = useState([]);
    const [filteredCategories, setFilteredCategories] = useState([]);

    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');
    

    useEffect(()=> {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            requester.findAllCategories({ storeId: "root" }, (result) => {
                
                setCategories(result.data);
            });
        }
    }, [isMounted]);
    

    // 검색 컴포넌트 기능
    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };
    
    // 검색어가 변경될 때마다 카테고리 리스트 필터링
    useEffect(() => {
        if (!searchKeyword) {
            setFilteredCategories(categories); // 검색어가 없으면 모든 카테고리를 표시
        } else {
            // 검색어가 있으면 해당 검색어를 포함하는 카테고리만 필터링하여 표시
            const filtered = categories.filter(product => 
                product.categoryName.toLowerCase().includes(searchKeyword.toLowerCase())
            );
            setFilteredCategories(filtered);
        }
    }, [searchKeyword, categories]); // searchKeyword 또는 categories가 변경될 때마다 실행

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>카테고리 관리</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색 창 */}
                        <AdminMobileSearchInput placeholder="카테고리를 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild>
                        {/* 카테고리 리스트 출력 */}
                        <AdminMobileCateList categories={filteredCategories} />
                    </FlexChild>
                </VerticalFlex>
                {/* 등록 페이지 이동 버튼 */}
                <AdminMobileRegisterBtn to="/admin/mobile/storeCate/register" />
            </Container>
        </div>
    );
};

export default AdminMobileCategory;